import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { bin as d3Bin, group, thresholdScott, extent } from 'd3-array';
import { defined, subObject } from '../utils/helper';
import { GroupN } from './groupN';
import { columnOf } from './utils/helper';
var THRESHOLD = 'thresholds';
/**
 * @see https://github.com/observablehq/plot/blob/main/src/transforms/bin.js
 */
function thresholdAuto(values) {
  var _extent = extent(values),
    _extent2 = _slicedToArray(_extent, 2),
    min = _extent2[0],
    max = _extent2[1];
  return Math.min(200, thresholdScott(values, min, max));
}
/**
 * The Bin aggregate data.
 * @todo More threshold method.
 * @todo Performance.
 */
export var Bin = function Bin() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$groupChannel = options.groupChannels,
    groupChannels = _options$groupChannel === void 0 ? ['color'] : _options$groupChannel,
    _options$binChannels = options.binChannels,
    binChannels = _options$binChannels === void 0 ? ['x', 'y'] : _options$binChannels,
    rest = __rest(options, ["groupChannels", "binChannels"]);
  var channelIndexKey = {};
  // Group indexes and update channelIndexKey.
  var groupBy = function groupBy(I, mark) {
    var encode = mark.encode;
    var binValues = binChannels.map(function (channel) {
      var _columnOf = columnOf(encode, channel),
        _columnOf2 = _slicedToArray(_columnOf, 1),
        V = _columnOf2[0];
      return V;
    });
    var thresholds = subObject(rest, THRESHOLD);
    var DI = I.filter(function (i) {
      return binValues.every(function (V) {
        return defined(V[i]);
      });
    });
    // Group indexes by both discrete and quantitative channels.
    var groupKeys = [].concat(_toConsumableArray(groupChannels.map(function (d) {
      var _columnOf3 = columnOf(encode, d),
        _columnOf4 = _slicedToArray(_columnOf3, 1),
        V = _columnOf4[0];
      return V;
    }).filter(defined).map(function (V) {
      return function (i) {
        return V[i];
      };
    })), _toConsumableArray(binChannels.map(function (d, i) {
      var V = binValues[i];
      var t = thresholds[d] || thresholdAuto(V);
      var bins = d3Bin().thresholds(t).value(function (i) {
        return +V[i];
      })(DI);
      var indexKey = new Map(bins.flatMap(function (bin) {
        var x0 = bin.x0,
          x1 = bin.x1;
        var key = "".concat(x0, ",").concat(x1);
        return bin.map(function (i) {
          return [i, key];
        });
      }));
      channelIndexKey[d] = indexKey;
      return function (i) {
        return indexKey.get(i);
      };
    })));
    // Group by indexes by channel keys.
    var key = function key(i) {
      return groupKeys.map(function (key) {
        return key(i);
      }).join('-');
    };
    return Array.from(group(DI, key).values());
  };
  return GroupN(Object.assign(Object.assign(Object.assign({}, Object.fromEntries(Object.entries(rest).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      k = _ref2[0];
    return !k.startsWith(THRESHOLD);
  }))), Object.fromEntries(binChannels.flatMap(function (channel) {
    var start = function start(_ref3) {
      var _ref4 = _slicedToArray(_ref3, 1),
        i = _ref4[0];
      return +channelIndexKey[channel].get(i).split(',')[0];
    };
    var end = function end(_ref5) {
      var _ref6 = _slicedToArray(_ref5, 1),
        i = _ref6[0];
      return +channelIndexKey[channel].get(i).split(',')[1];
    };
    end.from = channel;
    return [[channel, start], ["".concat(channel, "1"), end]];
  }))), {
    groupBy: groupBy
  }));
};
Bin.props = {};